const calendarRoutes = {
  path: "calendar",
  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/calendar/calendar");
        const Calendar = mod.default;
        return { Component: Calendar };
      },
    },
  ],
};

export default calendarRoutes;
